// ===== Helpers slide =====
function _s(o, i, p, l) {
    void 0 === i && (i = 400);
    void 0 === l && (l = !1);
    o.style.overflow = "hidden";
    l && (o.style.display = "block");
    var n,
        t = window.getComputedStyle(o),
        s = parseFloat(t.getPropertyValue("height")),
        a = parseFloat(t.getPropertyValue("padding-top")),
        r = parseFloat(t.getPropertyValue("padding-bottom")),
        y = parseFloat(t.getPropertyValue("margin-top")),
        d = parseFloat(t.getPropertyValue("margin-bottom")),
        g = s / i,
        m = a / i,
        h = r / i,
        u = y / i,
        x = d / i;
    window.requestAnimationFrame(function t(e) {
        void 0 === n && (n = e);
        e -= n;
        l
            ? ((o.style.height = g * e + "px"),
                (o.style.paddingTop = m * e + "px"),
                (o.style.paddingBottom = h * e + "px"),
                (o.style.marginTop = u * e + "px"),
                (o.style.marginBottom = x * e + "px"))
            : ((o.style.height = s - g * e + "px"),
                (o.style.paddingTop = a - m * e + "px"),
                (o.style.paddingBottom = r - h * e + "px"),
                (o.style.marginTop = y - u * e + "px"),
                (o.style.marginBottom = d - x * e + "px"));
        if (i <= e) {
            o.style.height = "";
            o.style.paddingTop = "";
            o.style.paddingBottom = "";
            o.style.marginTop = "";
            o.style.marginBottom = "";
            o.style.overflow = "";
            l || (o.style.display = "none");
            if (typeof p === "function") p();
        } else window.requestAnimationFrame(t);
    });
}
HTMLElement.prototype.slideToggle = function (t, e) {
    0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e);
};
HTMLElement.prototype.slideUp = function (t, e) {
    _s(this, t, e);
};
HTMLElement.prototype.slideDown = function (t, e) {
    _s(this, t, e, !0);
};

// ===== Composant =====
class CollectionSubV2 extends HTMLElement {
    constructor() {
        super();

        // États de filtres (exclusifs)
        this.activeCollection = null;

        // Bundle
        this.bundleItems = new Map();

        // Selling plan
        this.activeSubIndex = 1;
        this.mainPlanSelect = null; // (legacy)
        this.stickyPlanSelect = null; // (legacy)

        // Libellés courts configurables ("1 mois" / "3 mois" via settings)
        this.subShortLabels = {
            1: this.dataset.sub1Label || "1 mois",
            2: this.dataset.sub2Label || "3 mois",
        };
        this.currentSubShort = this.subShortLabels[1];

        // "Voir plus"
        this.showAll = false;

        // Sticky desktop
        this.stickyDeskEl = null;
        this._onScrollStickyDesk = this.updateStickyDeskVisibility.bind(this);
        this._mmDesk = window.matchMedia("(min-width: 990px)");

        // Overlay mobile
        this.mobileOverlay = null;
        this._mmMobile = window.matchMedia("(max-width: 989px)");

        // Refs
        this.subBtnsMobile = null;
        this.subBtnsDesk = null;
        this.submitSelect = null;

        // Refs "Voir plus"
        this._showMoreBtn = null;
        this._hideShowMoreBtn = null;
        this._showShowMoreBtn = null;
    }

    connectedCallback() {
        // --- Filtres collections + "Tous les produits"
        this.querySelectorAll(".product-sub__filters--item").forEach((btn) => {
            btn.addEventListener("click", this.handleFilterClick.bind(this));
        });

        // --- Gestion quantité
        this.addEventListener("click", (ev) => {
            const initBtn = ev.target.closest(".product--quantity__init");
            if (initBtn && !initBtn.classList.contains("disabled")) {
                const card = initBtn.closest(".card-product-sub");
                const qtyInput = card?.querySelector('input.product-count[name="quantity"]');
                if (qtyInput && (parseInt(qtyInput.value || "0", 10) || 0) === 0)
                    this.setCardQuantity(card, 1);
            }

            const qtyBtn = ev.target.closest(".quantity-input__btn");
            if (qtyBtn) {
                const card = qtyBtn.closest(".card-product-sub");
                if (!card) return;
                const action = qtyBtn.dataset.action;
                if (action === "increment") this.incrementCard(card);
                else if (action === "decrement") this.decrementCard(card);
            }
        });

        this.addEventListener("change", (ev) => {
            const input = ev.target.closest("input.product-count");
            if (!input) return;
            const card = input.closest(".card-product-sub");
            if (!card) return;
            this.updateAddButtonVisibility(card);
            this.updateBundleForCard(card);

            const handle = input?.dataset.handle || card.dataset.handle;
            if (handle) this.syncQuantityAcrossCards(handle, input.value, card);
        });

        // --- Toggle sticky (FAQ)
        this.querySelectorAll(".product-collection__sticky--content-header").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem2.bind(this));
        });

        // --- État initial + rendu
        this.applyFilters();
        this.querySelectorAll(".card-product-sub").forEach((card) => {
            this.updateAddButtonVisibility(card);
            this.updateBundleForCard(card);
        });

        // Synchroniser l'état visuel du bouton "all"
        this.syncAllButtonState();

        // --- Abonnements + synchro
        this.initSellingPlanSync();

        // --- Submit bundle
        const submitBtns = this.querySelectorAll(".product-collection__sticky--content-submit-button");
        submitBtns.forEach((submitBtn) => {
            submitBtn.addEventListener("click", (e) => {
                e.preventDefault();
                this.addBundleToCart();
            });
        });

        this.addEventListener("bundle:updated", (ev) => {
            this.renderStickySummary(ev.detail?.bundle);
        });
        this.renderStickySummary(this.getBundleSnapshot());

        // --- Délégation qty depuis sticky
        const onStickyClick = (ev) => {
            const btn = ev.target.closest(".quantity-input__btn");
            if (!btn) return;
            const handle = btn.dataset.handle;
            if (!handle) return;

            const container = btn.closest(".sticky-item__qty-control");
            const input = container?.querySelector(".sticky-qty-input");
            const display = container?.querySelector("span");
            if (!input || !display) return;

            const action = btn.dataset.action;
            const current = Math.max(0, parseInt(input.value, 10) || 0);
            const next = action === "increment" ? current + 1 : Math.max(0, current - 1);

            input.value = String(next);
            display.textContent = String(next);
            this.setHandleQuantity(handle, next);
        };
        const onStickyChange = (ev) => {
            const inp = ev.target.closest(".sticky-qty-input");
            if (!inp) return;
            const handle = inp.dataset.handle;
            if (!handle) return;
            const v = Math.max(0, parseInt(inp.value, 10) || 0);
            inp.value = String(v);
            const display = inp.parentElement?.querySelector("span");
            if (display) display.textContent = String(v);
            this.setHandleQuantity(handle, v);
        };

        this.addEventListener("click", onStickyClick);
        this.addEventListener("change", onStickyChange);

        // --- Voir plus
        this.initShowMore();

        // --- Nettoyage URL
        this.updateURLFromState();

        // --- Sticky desktop visible seulement après la section (≥990px)
        this.stickyDeskEl = this.querySelector(".product-collection__sticky");
        if (this.stickyDeskEl) {
            this.stickyDeskEl.style.display = "none";
            window.addEventListener("scroll", this._onScrollStickyDesk, { passive: true });
            window.addEventListener("resize", this._onScrollStickyDesk);
            if (this._mmDesk?.addEventListener) this._mmDesk.addEventListener("change", this._onScrollStickyDesk);
            this.updateStickyDeskVisibility();
        }

        // --- Overlay mobile pour FAQ sticky
        this.ensureMobileOverlay();
    }

    /* =======================
     *        FILTRES
     * ======================= */

    // 🧹 Reset visuel de tous les filtres
    resetFiltersUI() {
        this.querySelectorAll('.product-sub__filters--item.active').forEach((b) => b.classList.remove("active"));
    }

    // 🖱️ Handler du clic sur un filtre (collection ou all)
    handleFilterClick(e) {
        const btn = e.currentTarget;
        const type = btn.dataset.filter;
        const val = (btn.dataset.value || "").trim();
        const wasActive = btn.classList.contains("active");

        // Reset visuel
        this.resetFiltersUI();

        if (type === "all" || wasActive) {
            // Clic sur "all" ou désélection → aucun filtre actif
            this.activeCollection = null;
            this.querySelector('[data-filter="all"]')?.classList.add("active");
        } else if (type === "collection") {
            // Activer ce filtre collection
            this.activeCollection = val || null;
            btn.classList.add("active");
        }

        this.applyFilters();
    }

    // Sync le bouton "all" si aucun filtre actif
    syncAllButtonState() {
        const allBtn = this.querySelector('.product-sub__filters--item[data-filter="all"]');
        if (!allBtn) return;
        const shouldBeActive = !this.activeCollection;
        allBtn.classList.toggle("active", shouldBeActive);
    }

    initShowMore() {
        const btn = this.querySelector("[data-show-more]");
        if (!btn) return;

        const hideBtn = () => {
            btn.setAttribute("aria-hidden", "true");
            btn.style.display = "none";
        };
        const showBtn = () => {
            btn.removeAttribute("aria-hidden");
            btn.style.display = "";
        };

        this._showMoreBtn = btn;
        this._hideShowMoreBtn = hideBtn;
        this._showShowMoreBtn = showBtn;

        btn.addEventListener("click", (e) => {
            e.preventDefault();
            this.showAll = true;
            this.getAllCards().forEach((card) => {
                if (card.style.display !== "none") card.classList.remove("hidden");
            });
            this.updateVisibleProductsCount?.();
            hideBtn();
        });
    }

    applyFilters() {
        const cards = this.getAllCards();
        const requiredCollection = this.activeCollection;

        const matching = [];
        cards.forEach((card) => {
            // Récupérer les collections/blocks du produit
            const cardCollections = new Set(
                (card.dataset.collection || "")
                    .split(",")
                    .map((v) => v.trim())
                    .filter(Boolean)
            );

            // Si aucun filtre actif → tout afficher
            // Sinon vérifier si la carte appartient à la collection filtrée
            let matchCollection = true;
            if (requiredCollection) {
                matchCollection = cardCollections.has(requiredCollection);
            }

            if (matchCollection) {
                matching.push(card);
                card.style.display = "";
            } else {
                card.style.display = "none";
                card.classList.remove("hidden");
            }
        });

        if (this.showAll) {
            matching.forEach((card) => card.classList.remove("hidden"));
        } else {
            matching.forEach((card, idx) => {
                if (idx < 8) card.classList.remove("hidden");
                else card.classList.add("hidden");
            });
        }

        const btn = this._showMoreBtn || this.querySelector("[data-show-more]");
        const totalMatching = matching.length;
        if (btn) {
            if (this.showAll || totalMatching <= 8) {
                this._hideShowMoreBtn ? this._hideShowMoreBtn() : (btn.style.display = "none");
            } else {
                this._showShowMoreBtn ? this._showShowMoreBtn() : (btn.style.display = "");
            }
        }

        this.updateVisibleProductsCount();
    }

    // Compteur
    getAllCards() {
        const grid = this.querySelector("#CollectionProductsContainer .grid") || this.querySelector(".grid");
        if (!grid) return [];
        return Array.from(grid.querySelectorAll(".card-product-sub"));
    }
    getVisibleProductsCount() {
        return this.getAllCards().reduce((acc, card) => {
            const style = getComputedStyle(card);
            const visible = style.display !== "none" && style.visibility !== "hidden" && !card.classList.contains("hidden");
            return acc + (visible ? 1 : 0);
        }, 0);
    }
    updateVisibleProductsCount() {
        const span = this.querySelector("[data-number-products]");
        if (!span) return;
        span.textContent = String(this.getVisibleProductsCount());
    }

    // URL
    loadFiltersFromURL() {}
    updateURLFromState() {
        try {
            const { pathname, hash } = window.location;
            history.replaceState(null, "", pathname + hash);
        } catch {}
    }

    /* =======================
     *     SELLING PLAN
     * ======================= */
    initSellingPlanSync() {
        this.subBtnsAll = Array.from(this.querySelectorAll(".product-sub__select-sub--item"));
        this.submitSelect = this.querySelector(".product-collection__sticky--content-submit .product-collection__sticky--content-select");

        const initialBtn = this.subBtnsAll.find((b) => b.classList.contains("active"));
        let initialIndex = 1;
        if (initialBtn) {
            const grp = initialBtn.closest(".product-collection__sticky--content-select, .product-collection__sticky-sub");
            const siblings = grp ? Array.from(grp.querySelectorAll(".product-sub__select-sub--item")) : [];
            initialIndex = Math.max(1, Math.min(2, siblings.indexOf(initialBtn) + 1));
        }
        if (!initialBtn && this.subBtnsAll.length) {
            initialIndex = 1;
            this.subBtnsAll[0].classList.add("active");
        }

        this.setActiveSubIndex(initialIndex);

        this._onSubBtnClick = (e) => {
            const btn = e.target.closest(".product-sub__select-sub--item");
            if (!btn || !this.contains(btn)) return;
            e.preventDefault();

            const group = btn.closest(".product-collection__sticky--content-select, .product-collection__sticky-sub");
            const btnsInGroup = group ? Array.from(group.querySelectorAll(".product-sub__select-sub--item")) : [];
            const idx = Math.max(1, Math.min(2, btnsInGroup.indexOf(btn) + 1));

            this.setActiveSubIndex(idx);
        };
        this.addEventListener("click", this._onSubBtnClick);

        if (this.submitSelect) {
            this._onSubmitSelectChange = (e) => {
                const idx = Math.max(1, Math.min(2, (e.currentTarget.selectedIndex ?? 0) + 1));
                this.setActiveSubIndex(idx);
            };
            this.submitSelect.addEventListener("change", this._onSubmitSelectChange);
        }
    }

    setActiveSubIndex(idx) {
        const index = Math.max(1, Math.min(2, parseInt(idx, 10) || 1));
        this.activeSubIndex = index;

        // Libellé court courant (depuis settings)
        this.currentSubShort = this.subShortLabels[index];

        // 1) Active le bon bouton dans chaque groupe
        const groups = Array.from(this.querySelectorAll(".product-collection__sticky--content-select, .product-collection__sticky-sub"));
        groups.forEach((grp) => {
            const btns = Array.from(grp.querySelectorAll(".product-sub__select-sub--item"));
            btns.forEach((b, i) => b.classList.toggle("active", i === index - 1));
        });

        // 2) Synchro SELECT footer
        if (this.submitSelect && this.submitSelect.selectedIndex !== index - 1) {
            this.submitSelect.selectedIndex = index - 1;
        }

        // 3) texte courant “Livraison …” (data-text du bouton)
        let subText = "";
        for (const grp of groups) {
            const btn = grp.querySelectorAll(".product-sub__select-sub--item")[index - 1];
            if (btn) { subText = (btn.dataset.text || btn.textContent || "").trim(); break; }
        }
        this.querySelectorAll(".current-subsription").forEach((el) => { el.textContent = subText; });

        this.updateCardsActiveVariantDisplay();
        this.refreshBundleActiveVariants();
        this.renderStickySummary(this.getBundleSnapshot());
        this.updateCardsCurrentSubLabels();
        this.updateStickyPriceRowsVisibility?.();
    }

    updateCardsCurrentSubLabels() {
        this.querySelectorAll(".sticky-item__current_sub").forEach((el) => {
            el.textContent = this.currentSubShort;
        });
    }

    updateStickyPriceRowsVisibility() {
        const showSecond = this.activeSubIndex === 2;
        this.querySelectorAll('.sticky-item__price-row[data-sub-1]').forEach((el) => {
            el.classList.toggle('hidden', showSecond);
        });
        this.querySelectorAll('.sticky-item__price-row[data-sub-2]').forEach((el) => {
            el.classList.toggle('hidden', !showSecond);
        });
    }

    updateCardsActiveVariantDisplay() {
        const showSecond = this.activeSubIndex === 2;
        this.querySelectorAll(".card-product-sub").forEach((card) => {
            card.querySelectorAll(".first-variant-price").forEach((el) => {
                el.classList.toggle("hidden", showSecond);
            });
            card.querySelectorAll(".second-variant-price").forEach((el) => {
                el.classList.toggle("hidden", !showSecond);
            });
        });
        this.updateStickyPriceRowsVisibility?.();
    }

    refreshBundleActiveVariants() {
        this.bundleItems.forEach((item) => {
            const v = this.activeSubIndex === 2 ? item.variants[1] || item.variants[0] : item.variants[0];
            if (v && v.id) {
                item.activeVariantId = v.id;
            } else if (item.variants[0] && item.variants[0].id) {
                // Fallback: toujours utiliser la première variante si la deuxième n'est pas disponible
                item.activeVariantId = item.variants[0].id;
            }
        });
    }

    /* =======================
     *     QUANTITÉS
     * ======================= */
    incrementCard(card) {
        const qtyInput = card.querySelector('input.product-count[name="quantity"]');
        if (!qtyInput) return;
        const current = parseInt(qtyInput.value || "0", 10) || 0;
        this.setCardQuantity(card, current + 1);
    }
    decrementCard(card) {
        const qtyInput = card.querySelector('input.product-count[name="quantity"]');
        if (!qtyInput) return;
        const current = parseInt(qtyInput.value || "0", 10) || 0;
        this.setCardQuantity(card, current - 1);
    }
    updateAddButtonVisibility(card) {
        const qtyInput = card.querySelector('input.product-count[name="quantity"]');
        const initBtn = card.querySelector(".product--quantity__init");
        if (!qtyInput || !initBtn) return;
        const qty = parseInt(qtyInput.value || "0", 10) || 0;
        if (qty > 0) initBtn.classList.add("hidden");
        else initBtn.classList.remove("hidden");
    }
    setCardQuantity(card, newQty) {
        const qtyInput = card.querySelector('input.product-count[name="quantity"]');
        if (!qtyInput) return;
        const maxAttr = parseInt(qtyInput.getAttribute("max") || "1000", 10);
        const max = isNaN(maxAttr) ? 1000 : maxAttr;
        const clamped = Math.max(0, Math.min(max, parseInt(newQty, 10) || 0));

        if (String(qtyInput.value) !== String(clamped)) {
            qtyInput.value = String(clamped);
            qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
            qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
        this.updateAddButtonVisibility(card);
        this.updateBundleForCard(card);

        const handle = qtyInput?.dataset.handle || card.dataset.handle;
        if (handle) this.syncQuantityAcrossCards(handle, clamped, card);
    }

    getCardsByHandle(handle) {
        if (!handle) return [];
        return this.getAllCards().filter((c) => {
            const h = c.dataset.handle || c.querySelector("input.product-count")?.dataset.handle;
            return String(h) === String(handle);
        });
    }
    setHandleQuantity(handle, qty) {
        const v = Math.max(0, parseInt(qty, 10) || 0);
        const cards = this.getCardsByHandle(handle);

        if (cards.length > 0) {
            this.setCardQuantity(cards[0], v);
        } else {
            const item = this.bundleItems.get(handle);
            if (item) {
                item.quantity = v;
                if (v === 0) this.bundleItems.delete(handle);
                this.dispatchEvent(new CustomEvent("bundle:updated", { bubbles: true, detail: { bundle: this.getBundleSnapshot() } }));
            }
        }
    }
    syncQuantityAcrossCards(handle, value, sourceCard = null) {
        const cards = this.getCardsByHandle(handle);
        cards.forEach((card) => {
            if (sourceCard && card === sourceCard) return;
            const input = card.querySelector('input.product-count[name="quantity"]');
            if (!input) return;
            const v = Math.max(0, parseInt(value, 10) || 0);
            if (String(input.value) !== String(v)) {
                input.value = String(v);
            }
            this.updateAddButtonVisibility(card);
            this.updateBundleForCard(card);
        });
    }

    /* =======================
     *        STICKY
     * ======================= */
    toggleFaqItem2(e) {
        const container = e.currentTarget.closest(".product-collection__sticky--content");
        if (!container) return;
        container.classList.toggle("faq-item-active");
        const item = container.querySelector(".product-collection__sticky--container-bottom");
        if (item) item.slideToggle("250");
    }

    ensureMobileOverlay() {
        if (this.mobileOverlay) return;
        const ov = document.createElement("div");
        ov.className = "collection-sub-overlay";
        ov.style.display = "none";
        ov.addEventListener("click", () => {
            let container = document.querySelector(".product-collection__sticky--content");
            if (!container) return;
            container.classList.toggle("faq-item-active");
            const item = container.querySelector(".product-collection__sticky--container-bottom");
            if (item) item.slideToggle("250");
            this.toggleOverlay(false);
        });
        document.body.appendChild(ov);
        this.mobileOverlay = ov;

        this.addEventListener("click", (e) => {
            const header = e.target.closest(".product-collection__sticky--content-header");
            if (!header) return;
            const container = header.closest(".product-collection__sticky--content");
            if (!container) return;
            requestAnimationFrame(() => {
                const isOpen = container.classList.contains("faq-item-active");
                this.toggleOverlay(isOpen);
            });
        });
    }
    toggleOverlay(show) {
        const isMobile = this._mmMobile?.matches ?? window.innerWidth <= 989;
        if (!this.mobileOverlay || !isMobile) {
            if (this.mobileOverlay) this.mobileOverlay.style.display = "none";
            return;
        }
        this.mobileOverlay.style.display = show ? "block" : "none";
        document.documentElement.classList.toggle("no-scroll", !!show);
        document.body.classList.toggle("no-scroll", !!show);
    }

    updateStickyDeskVisibility() {
        if (!this.stickyDeskEl) return;
        const isDesk = this._mmDesk?.matches ?? window.innerWidth >= 990;
        if (!isDesk) {
            this.stickyDeskEl.style.display = "none";
            return;
        }
        const rect = this.getBoundingClientRect();
        const sectionBottomPassed = rect.bottom <= 0;
        this.stickyDeskEl.style.display = sectionBottomPassed ? "" : "none";
    }

    /* =======================
     *        BUNDLE
     * ======================= */
    readCardData(card) {
        const titleEl = card.querySelector(".product-card__title span");
        const title = titleEl ? titleEl.textContent.trim() : "";

        const qtyInput = card.querySelector('input.product-count[name="quantity"]');
        const qty = qtyInput ? parseInt(qtyInput.value || "0", 10) : 0;

        const handle = qtyInput?.dataset.handle || card.dataset.handle || title;
        const image = qtyInput?.dataset.image || "";

        const v1 = qtyInput?.dataset.variant1 || qtyInput?.dataset["variant-1"] || null;
        const v2 = qtyInput?.dataset.variant2 || qtyInput?.dataset["variant-2"] || null;

        const v1Base = qtyInput?.dataset.price ? parseInt(qtyInput.dataset.price, 10) : null;
        const v2Base = qtyInput?.dataset.price2 ? parseInt(qtyInput.dataset.price2, 10) : null;
        const v1Cmp = qtyInput?.dataset.comparedPrice ? parseInt(qtyInput.dataset.comparedPrice, 10) : null;
        const v2Cmp = qtyInput?.dataset.comparedPrice2 ? parseInt(qtyInput.dataset.comparedPrice2, 10) : null;

        const sp1v1 = qtyInput?.dataset.sp1V1 ? parseInt(qtyInput.dataset.sp1V1, 10) : null;
        const sp2v1 = qtyInput?.dataset.sp2V1 ? parseInt(qtyInput.dataset.sp2V1, 10) : null;
        const sp1v2 = qtyInput?.dataset.sp1V2 ? parseInt(qtyInput.dataset.sp1V2, 10) : null;
        const sp2v2 = qtyInput?.dataset.sp2V2 ? parseInt(qtyInput.dataset.sp2V2, 10) : null;

        const v1PriceText = card.querySelector(".first-variant-price .font-semibold")?.textContent || "";
        const v1CompareText = card.querySelector(".first-variant-price .line-through")?.textContent || "";
        const v2PriceText = card.querySelector(".second-variant-price .font-semibold")?.textContent || "";
        const v2CompareText = card.querySelector(".second-variant-price .line-through")?.textContent || "";

        const sp1 = qtyInput?.dataset.sellingPlan1 || qtyInput?.getAttribute("data-selling-plan-1") || null;
        const sp2 = qtyInput?.dataset.sellingPlan2 || qtyInput?.getAttribute("data-selling-plan-2") || null;
        const sellingPlansByIndex = { 1: sp1, 2: sp2 || sp1 };

        const activeVariantId = this.activeSubIndex === 2 ? v2 || v1 : v1 || v2;

        const ensure = (n, fb = null) => (Number.isFinite(n) ? n : fb);
        const parseMoneyToCents = (str) => this.parseMoneyToCents(str);

        const variants = [];
        if (v1) variants.push({
            id: v1,
            base_price_cents: ensure(v1Base, parseMoneyToCents(v1PriceText) ?? 0),
            compare_at_price_cents: ensure(v1Cmp, parseMoneyToCents(v1CompareText) ?? ensure(v1Base, 0)),
            sp_prices: { 1: ensure(sp1v1, null), 2: ensure(sp2v1, ensure(sp1v1, null)) },
            price_text: (v1PriceText || "").trim(),
            compare_at_text: (v1CompareText || "").trim(),
        });
        if (v2) variants.push({
            id: v2,
            base_price_cents: ensure(v2Base, parseMoneyToCents(v2PriceText) ?? 0),
            compare_at_price_cents: ensure(v2Cmp, parseMoneyToCents(v2CompareText) ?? ensure(v2Base, 0)),
            sp_prices: { 1: ensure(sp1v2, null), 2: ensure(sp2v2, ensure(sp1v2, null)) },
            price_text: (v2PriceText || "").trim(),
            compare_at_text: (v2CompareText || "").trim(),
        });

        return {
            handle,
            title,
            image,
            quantity: isNaN(qty) ? 0 : qty,
            variants,
            activeVariantId,
            sellingPlansByIndex,
        };
    }

    parseMoneyToCents(str) {
        if (!str) return null;
        let s = String(str).replace(/\u00A0|\u202F/g, " ").replace(/[^\d.,-]/g, "").trim();
        if (!s) return null;
        const lastDot = s.lastIndexOf("."), lastComma = s.lastIndexOf(",");
        if (lastDot !== -1 && lastComma !== -1) {
            if (lastDot < lastComma) s = s.replace(/\./g, "").replace(",", ".");
            else s = s.replace(/,/g, "");
        } else if (lastComma !== -1) s = s.replace(",", ".");
        const num = parseFloat(s);
        if (isNaN(num)) return null;
        return Math.round(num * 100);
    }

    updateBundleForCard(card) {
        const data = this.readCardData(card);
        if (!data) return;
        if (data.quantity > 0) this.bundleItems.set(data.handle, data);
        else this.bundleItems.delete(data.handle);
        this.dispatchEvent(new CustomEvent("bundle:updated", { bubbles: true, detail: { bundle: this.getBundleSnapshot() } }));
    }

    getBundleSnapshot() {
        const items = [];
        this.bundleItems.forEach((item) => {
            const v = this.activeSubIndex === 2 ? item.variants[1] || item.variants[0] : item.variants[0];
            items.push({
                handle: item.handle,
                title: item.title,
                image: item.image,
                quantity: item.quantity,
                active_variant_id: v?.id || null,
                price_cents: typeof v?.price_cents === "number" ? v.price_cents : null,
                compare_at_price_cents: typeof v?.compare_at_price_cents === "number" ? v.price_cents : null,
                price_text: v?.price_text ?? "",
                compare_at_text: v?.compare_at_text ?? "",
                variants: item.variants,
                sellingPlansByIndex: item.sellingPlansByIndex,
            });
        });
        const total_cents = items.reduce((sum, it) => {
            const p = typeof it.price_cents === "number" ? it.price_cents : 0;
            return sum + p * (it.quantity || 0);
        }, 0);
        return { items, total_cents };
    }

    formatCents(cents) {
        if (typeof cents !== "number") return "";
        return (cents / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "€";
    }
    escapeHTML(str) {
        return String(str || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
    }

    renderStickySummary(bundle) {
        const stickyLists = Array.from(this.querySelectorAll(".product-collection__sticky--content-contenue, .product-collection__sticky-desk__products"));
        const buyBtns = Array.from(this.querySelectorAll(".product-collection__sticky--content-submit-button"));
        const priceEls = Array.from(this.querySelectorAll(".product-collection__sticky--content-submit-price"));
        const cmpEls = Array.from(this.querySelectorAll(".product-collection__sticky--content-submit-compare-price"));
        if (stickyLists.length === 0 || priceEls.length === 0 || cmpEls.length === 0) return;

        const snap = bundle || this.getBundleSnapshot();
        const items = (snap?.items || []).filter((it) => (it.quantity || 0) > 0);

        if (items.length === 0) {
            stickyLists.forEach((sticky) => (sticky.innerHTML = ""));
            buyBtns.forEach((btn) => btn.setAttribute("disabled", "disabled"));
            priceEls.forEach((el) => (el.textContent = ""));
            cmpEls.forEach((el) => (el.textContent = ""));
            return;
        }

        const current_sub = this.currentSubShort;

        const html = items
            .map((it) => {
                const title = this.escapeHTML(it.title);
                const img = this.escapeHTML(it.image);
                const qty = Number(it.quantity) || 0;
                const handle = this.escapeHTML(it.handle);

                const variantsHTML = (it.variants?.length
                    ? it.variants
                    : [{ id: it.active_variant_id, price_text: it.price_text, compare_at_text: it.compare_at_text }])
                    .map((v, idx0) => {
                        const index = Math.min(2, Math.max(1, idx0 + 1));
                        const priceTxt = (v.price_text && v.price_text.trim()) ? v.price_text.trim() : "";
                        const compareTxt = (v.compare_at_text && v.compare_at_text.trim()) ? v.compare_at_text.trim() : "";
                        const hiddenClass = index !== this.activeSubIndex ? "hidden" : "";
                        return `
              <div class="sticky-item__price-row ${hiddenClass}" data-sub-${index} data-variant-id="${this.escapeHTML(v.id || "")}">
                <span class="sticky-item__price">${this.escapeHTML(priceTxt)}</span>
                <span class="sticky-item__compare" style="opacity:.6;">${this.escapeHTML(compareTxt)}</span>
              </div>`;
                    })
                    .join("");

                const qtyHTML = `
          <div class="sticky-item__qty-control" data-handle="${handle}">
            <button class="quantity-input__btn" type="button" data-action="decrement" aria-label="Diminuer" data-handle="${handle}">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M1.5 6.72857H5.2271H6.75573H10.5V5.28857H6.75573H5.2271H1.5V6.72857Z" fill="#352045"/></svg>
            </button>
            <input class="sticky-qty-input hidden" type="number" min="0" value="${qty}" data-handle="${handle}" inputmode="numeric" />
            <span>${qty}</span>
            <button class="quantity-input__btn" type="button" data-action="increment" aria-label="Augmenter" data-handle="${handle}">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M5.2271 10.5V6.72857H1.5V5.28857H5.2271V1.5H6.75573V5.28857H10.5V6.72857H6.75573V10.5H5.2271Z" fill="#352045"/></svg>
            </button>
          </div>`;

                return `
          <div class="sticky-item" data-handle="${handle}">
            <div class="sticky-item__image">${img ? `<img src="${img}" alt="${title}" />` : ""}</div>
            <div class="sticky-item__infos">
              <div class="sticky-item__infos-left">
                <div class="sticky-item__title">${title}</div>
                <div class="sticky-item__current_sub p-extra-small">${this.escapeHTML(current_sub)}</div>
                <div class="sticky-item__prices">${variantsHTML}</div>
              </div>
              ${qtyHTML}
            </div>
          </div>`;
            })
            .join("");

        stickyLists.forEach((sticky) => {
            sticky.innerHTML = html;
        });

        let totalSub = 0, totalOrigin = 0;
        const planIdx = this.activeSubIndex === 2 ? 2 : 1;

        items.forEach((it) => {
            const v =
                it.variants?.find((vv) => String(vv.id) === String(it.active_variant_id)) ||
                it.variants?.[this.activeSubIndex - 1] ||
                it.variants?.[0] ||
                null;

            const priceTxt = v?.price_text?.replace(/[^0-9.,-]/g, "").replace(",", ".").trim();
            const priceNum = Number(priceTxt) * 100;

            const q = Number(it.quantity) || 0;
            const sub = v?.sp_prices?.[planIdx] ?? v?.base_price_cents ?? 0;
            const origin = typeof v?.compare_at_price_cents === "number" ? v.compare_at_price_cents : v?.base_price_cents ?? sub;

            totalSub += (Number.isFinite(priceNum) ? priceNum : sub) * q;
            totalOrigin += origin * q;
        });

        priceEls.forEach((el) => (el.textContent = this.formatCents(totalSub)));
        cmpEls.forEach((el) => {
            el.textContent = this.formatCents(totalOrigin);
            el.style.display = "";
        });
        buyBtns.forEach((btn) => btn.removeAttribute("disabled"));
    }

    buildCartPayloadFromBundle() {
        const items = [];
        this.bundleItems.forEach((data) => {
            if (!data || !data.quantity || !data.activeVariantId) return;
            // Utiliser le selling plan correspondant à l'index actif (1 ou 2)
            // sp1 = selling plan pour variante 1 (abonnement 1 mois)
            // sp2 = selling plan pour variante 2 (abonnement 3 mois)
            const planIdRaw = data.sellingPlansByIndex?.[this.activeSubIndex] || null;
            const planId = planIdRaw && !isNaN(Number(planIdRaw)) ? Number(planIdRaw) : planIdRaw || null;
            const line = { id: Number(data.activeVariantId), quantity: Number(data.quantity) };
            if (planId) line.selling_plan = planId;
            items.push(line);
        });
        return { items };
    }

    async addBundleToCart() {
        const payload = this.buildCartPayloadFromBundle();
        if (!payload.items || payload.items.length === 0) return;
        const btn = this.querySelector(".product-collection__sticky--content-submit-button");
        if (btn) btn.setAttribute("disabled", "disabled");
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
        try {
            const res = await fetch(`${root}cart/add.js`, {
                method: "POST",
                credentials: "same-origin",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify(payload),
            });
            const data = await res.json();
            if (!res.ok)
                throw new Error(data?.description || data?.message || "Impossible d’ajouter les articles au panier.");
            this.dispatchEvent(new CustomEvent("bundle:added", { bubbles: true, detail: { cartResponse: data, payload } }));
            const cartDrawer = document.querySelector("apt-cart-drawer");
            if (cartDrawer?.refresh) cartDrawer.refresh();
            else cartDrawer?.dispatchEvent(new CustomEvent("refresh"));
            if (cartDrawer?.open) cartDrawer.open();
            else cartDrawer?.classList.add("is-open");
        } catch (err) {
            console.error("[Bundle] Erreur add to cart:", err);
        } finally {
            if (btn) btn.removeAttribute("disabled");
        }
    }
}

// IMPORTANT : enregistrer le même tag que dans le template
if (!customElements.get("collection-sub-v2")) {
    customElements.define("collection-sub-v2", CollectionSubV2);
}
